import React, { useState } from "react";
import "./style.css";

const Filters = () => {
  return (
    <div className="top-btn-group mb-2 d-flex border-top-0">
      <div className="dropdown">
        <button
          className="btn-outline-bl"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          data-bs-auto-close="outside"
        >
          School
          <span class="position-absolute  translate-middle p-2  border border-light rounded-circle">
              <span class="numbr">0</span>
            </span>
        </button>
        <ul className="dropdown-menu check-drodrown">
          <li>
            <input
              id="search?"
              className="form-control me-2"
              type="search"
              aria-label="Search"
            />
          </li>
          <li>
            <div className="form-check py-1">
              <input
                className="form-check-input checked-school"
                type="checkbox"
                value=""
                id="reportSchool-a"
              />
              <label className="form-check-label" htmlFor="reportSchool-a">
                A
              </label>
            </div>
          </li>
          <li>
            <div className="form-check pb-1">
              <input
                className="form-check-input checked-school"
                type="checkbox"
                value=""
                id="reportSchool-b"
              />
              <label className="form-check-label" htmlFor="reportSchool-b">
                B
              </label>
            </div>
          </li>
          <li>
            <div className="form-check pb-1">
              <input
                className="form-check-input checked-school"
                type="checkbox"
                value=""
                id="reportSchool-c"
              />
              <label className="form-check-label" htmlFor="reportSchool-c">
                C
              </label>
            </div>
          </li>
        </ul>
      </div>
      <div className="dropdown">
        <button
          className="btn-outline-bl"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          data-bs-auto-close="outside"
        >
          Class
          <span class="position-absolute  translate-middle p-2  border border-light rounded-circle">
              <span class="numbr">0</span>
            </span>
        </button>

        <ul className="dropdown-menu check-drodrown">
          <li>
            <input
              id="search"
              className="form-control me-2"
              type="search"
              aria-label="Search"
            />
          </li>
          <li>
            <div className="form-check py-1">
              <input
                className="form-check-input checked-class"
                type="checkbox"
                value=""
                id="reportClass-a"
              />
              <label className="form-check-label" htmlFor="reportClass-a">
                A
              </label>
            </div>
          </li>
          <li>
            <div className="form-check pb-1">
              <input
                className="form-check-input checked-class"
                type="checkbox"
                value=""
                id="reportClass-b"
              />
              <label className="form-check-label" htmlFor="reportClass-b">
                B
              </label>
            </div>
          </li>
          <li>
            <div className="form-check pb-1">
              <input
                className="form-check-input checked-class"
                type="checkbox"
                value=""
                id="reportClass-c"
              />
              <label className="form-check-label" htmlFor="reportClass-c">
                C
              </label>
            </div>
          </li>
        </ul>
      </div>
      <div className="dropdown">
        <button
          className="btn-outline-bl"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          data-bs-auto-close="outside"
        >
          Section
         <span class="position-absolute  translate-middle p-2  border border-light rounded-circle">
              <span class="numbr">0</span>
            </span>
        </button>
        <ul className="dropdown-menu check-drodrown">
          <li>
            <input
              id="search"
              className="form-control me-2"
              type="search"
              aria-label="Search"
            />
          </li>
          <li>
            <div className="form-check py-1">
              <input
                className="form-check-input checked-section"
                type="checkbox"
                value=""
                id="reportSection-a"
              />
              <label className="form-check-label" htmlFor="reportSection-a">
                A
              </label>
            </div>
          </li>
          <li>
            <div className="form-check pb-1">
              <input
                className="form-check-input checked-section"
                type="checkbox"
                value=""
                id="reportSection-b"
              />
              <label className="form-check-label" htmlFor="reportSection-b">
                B
              </label>
            </div>
          </li>
          <li>
            <div className="form-check pb-1">
              <input
                className="form-check-input checked-section"
                type="checkbox"
                value=""
                id="reportSection-c"
              />
              <label className="form-check-label" htmlFor="reportSection-c">
                C
              </label>
            </div>
          </li>
        </ul>
      </div>
      <div className="dropdown">
        <button
          className="btn-outline-bl"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          data-bs-auto-close="outside"
        >
          Student Name
          <span class="position-absolute  translate-middle p-2  border border-light rounded-circle">
              <span class="numbr">0</span>
            </span>
        </button>
        <ul className="dropdown-menu check-drodrown">
          <li>
            <input
              id="search"
              className="form-control me-2"
              type="search"
              aria-label="Search"
            />
          </li>
          <li>
            <div className="form-check py-1">
              <input
                className="form-check-input checked-name"
                type="checkbox"
                value=""
                id="reportStudentName-a"
              />
              <label className="form-check-label" htmlFor="reportStudentName-a">
                A
              </label>
            </div>
          </li>
          <li>
            <div className="form-check pb-1">
              <input
                className="form-check-input checked-name"
                type="checkbox"
                value=""
                id="reportStudentName-b"
              />
              <label className="form-check-label" htmlFor="reportStudentName-b">
                B
              </label>
            </div>
          </li>
          <li>
            <div className="form-check pb-1">
              <input
                className="form-check-input checked-name"
                type="checkbox"
                value=""
                id="reportStudentName-c"
              />
              <label className="form-check-label" htmlFor="reportStudentName-c">
                C
              </label>
            </div>
          </li>
        </ul>
      </div>
      <div className="top-right-btn">
        <button className="m-0 btn-bl" type="button" aria-expanded="false">
          Download Report Card
        </button>
      </div>
    </div>
  );
};

export default Filters;
